import { render } from "./TlAssesment.vue?vue&type=template&id=a434ad80&scoped=true"
import script from "./TlAssesment?vue&type=script&lang=js"
export * from "./TlAssesment?vue&type=script&lang=js"

import "./TlAssesment.vue?vue&type=style&index=0&id=a434ad80&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a434ad80"]])

export default __exports__